import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { first, throwIfEmpty } from 'rxjs/operators';
import { EmployeeRestService, SelfAddEnterpriseDto } from 'src/app/api/exa';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EmployerService } from 'src/app/services/employer.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Utils } from 'src/app/services/utils';

import { ValidationErrorMessage } from '../validation-error/validation-error-message';

@Component({
  selector: 'app-employer-add-dialog',
  templateUrl: './employer-add-dialog.component.html',
  styleUrls: ['./employer-add-dialog.component.scss'],
})
export class EmployerAddDialogComponent implements OnInit {
  formGroup: UntypedFormGroup;

  validationMessages: { [key: string]: ValidationErrorMessage[] };

  constructor(
    private log: NGXLogger,
    private modalController: ModalController,
    private employeeRestService: EmployeeRestService,
    private empployerService: EmployerService,
    private errHandler: ErrorHandlerService,
    private alert: DialogService,
    private translate: TranslateService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl('', Validators.required),
    });
    this.validationMessages = {
      code: [
        { type: 'required', message: this.translate.instant('FORMS.REQUIRED') },
        // { type: 'minlength', message: 'Username must be at least 5 characters long.' },
      ],
    };
  }

  onClickOk() {
    Utils.validateAllFormFields(this.formGroup);
    if (this.formGroup.valid) {
      const request: SelfAddEnterpriseDto = { accessToken: this.formGroup.value.code };
      request.accessToken = request.accessToken.replace(/\s/g, '');
      this.employeeRestService
        .selfaddEmployeeUsingPOST(request)
        .toPromise()
        .then((ret) => {
          this.log.debug('selfAddEmployee ret:', ret);
          return this.auth.refreshToken(true);
        })
        .then((ret) => {
          // There's no need to refresh employers here the refreshtoken will do it
          this.log.debug('Employers refreshed:', ret);
          this.alert.presentToast(this.translate.instant('ENTERPRISE.ADDED.SUCCESS'));
          this.modalController.dismiss();
        })
        .catch((err) => {
          this.errHandler.handleHttpError(err);
        });
    }
  }

  onClickCancel() {
    this.modalController.dismiss({
      selected: false,
    });
  }
}
